import { Typography } from '@mui/material';
import React from 'react';

const ComingSoon = () => {
    return (
        <Typography variant='h6' sx={{fontWeight: 500, my: '20px'}}>
            Coming Soon!
        </Typography>
    )
}

export default ComingSoon;